/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateResumeTemplateBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllResumeTemplatesResponse } from '../models';
// @ts-ignore
import type { GetResumeTemplateResponse } from '../models';
// @ts-ignore
import type { RegenerateResumeTemplateImagesBody } from '../models';
// @ts-ignore
import type { RegenerateResumeTemplateImagesResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateResumeTemplateBody } from '../models';
// @ts-ignore
import type { UploadResumeTemplateResponse } from '../models';
/**
 * ResumeApiApi - axios parameter creator
 */
export const ResumeApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateResumeTemplateBody} createResumeTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiCreateResumeTemplate: async (createResumeTemplateBody: CreateResumeTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createResumeTemplateBody' is not null or undefined
            assertParamExists('resumeApiCreateResumeTemplate', 'createResumeTemplateBody', createResumeTemplateBody)
            const localVarPath = `/admin/resume/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createResumeTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiDeleteResumeTemplateById: async (resumeTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeTemplateId' is not null or undefined
            assertParamExists('resumeApiDeleteResumeTemplateById', 'resumeTemplateId', resumeTemplateId)
            const localVarPath = `/admin/resume/template/{resume_template_id}`
                .replace('{resume_template_id}', encodeURIComponent(String(resumeTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiGetResumeTemplateById: async (resumeTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeTemplateId' is not null or undefined
            assertParamExists('resumeApiGetResumeTemplateById', 'resumeTemplateId', resumeTemplateId)
            const localVarPath = `/resume/template/{resume_template_id}`
                .replace('{resume_template_id}', encodeURIComponent(String(resumeTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [category] 
         * @param {boolean} [isActive] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiGetResumeTemplateList: async (category?: string, isActive?: boolean, page?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resume/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegenerateResumeTemplateImagesBody} regenerateResumeTemplateImagesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiRegenerateResumeTemplateImages: async (regenerateResumeTemplateImagesBody: RegenerateResumeTemplateImagesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'regenerateResumeTemplateImagesBody' is not null or undefined
            assertParamExists('resumeApiRegenerateResumeTemplateImages', 'regenerateResumeTemplateImagesBody', regenerateResumeTemplateImagesBody)
            const localVarPath = `/admin/resume/template/regenerate-images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(regenerateResumeTemplateImagesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeTemplateId 
         * @param {UpdateResumeTemplateBody} updateResumeTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiUpdateResumeTemplateById: async (resumeTemplateId: string, updateResumeTemplateBody: UpdateResumeTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeTemplateId' is not null or undefined
            assertParamExists('resumeApiUpdateResumeTemplateById', 'resumeTemplateId', resumeTemplateId)
            // verify required parameter 'updateResumeTemplateBody' is not null or undefined
            assertParamExists('resumeApiUpdateResumeTemplateById', 'updateResumeTemplateBody', updateResumeTemplateBody)
            const localVarPath = `/admin/resume/template/{resume_template_id}`
                .replace('{resume_template_id}', encodeURIComponent(String(resumeTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateResumeTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {string} [resumeTemplateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiUploadResumeTemplateImage: async (imageFile: File, resumeTemplateId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageFile' is not null or undefined
            assertParamExists('resumeApiUploadResumeTemplateImage', 'imageFile', imageFile)
            const localVarPath = `/admin/resume/template/upload-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (resumeTemplateId !== undefined) {
                localVarQueryParameter['resume_template_id'] = resumeTemplateId;
            }


            if (imageFile !== undefined) { 
                localVarFormParams.append('image_file', imageFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResumeApiApi - functional programming interface
 */
export const ResumeApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResumeApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateResumeTemplateBody} createResumeTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeApiCreateResumeTemplate(createResumeTemplateBody: CreateResumeTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResumeTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeApiCreateResumeTemplate(createResumeTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ResumeApiApi.resumeApiCreateResumeTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeApiDeleteResumeTemplateById(resumeTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeApiDeleteResumeTemplateById(resumeTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ResumeApiApi.resumeApiDeleteResumeTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeApiGetResumeTemplateById(resumeTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResumeTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeApiGetResumeTemplateById(resumeTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ResumeApiApi.resumeApiGetResumeTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [category] 
         * @param {boolean} [isActive] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeApiGetResumeTemplateList(category?: string, isActive?: boolean, page?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllResumeTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeApiGetResumeTemplateList(category, isActive, page, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ResumeApiApi.resumeApiGetResumeTemplateList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegenerateResumeTemplateImagesBody} regenerateResumeTemplateImagesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeApiRegenerateResumeTemplateImages(regenerateResumeTemplateImagesBody: RegenerateResumeTemplateImagesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegenerateResumeTemplateImagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeApiRegenerateResumeTemplateImages(regenerateResumeTemplateImagesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ResumeApiApi.resumeApiRegenerateResumeTemplateImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeTemplateId 
         * @param {UpdateResumeTemplateBody} updateResumeTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeApiUpdateResumeTemplateById(resumeTemplateId: string, updateResumeTemplateBody: UpdateResumeTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResumeTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeApiUpdateResumeTemplateById(resumeTemplateId, updateResumeTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ResumeApiApi.resumeApiUpdateResumeTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {string} [resumeTemplateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeApiUploadResumeTemplateImage(imageFile: File, resumeTemplateId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadResumeTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeApiUploadResumeTemplateImage(imageFile, resumeTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ResumeApiApi.resumeApiUploadResumeTemplateImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ResumeApiApi - factory interface
 */
export const ResumeApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResumeApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ResumeApiApiResumeApiCreateResumeTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiCreateResumeTemplate(requestParameters: ResumeApiApiResumeApiCreateResumeTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetResumeTemplateResponse> {
            return localVarFp.resumeApiCreateResumeTemplate(requestParameters.createResumeTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResumeApiApiResumeApiDeleteResumeTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiDeleteResumeTemplateById(requestParameters: ResumeApiApiResumeApiDeleteResumeTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.resumeApiDeleteResumeTemplateById(requestParameters.resumeTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResumeApiApiResumeApiGetResumeTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiGetResumeTemplateById(requestParameters: ResumeApiApiResumeApiGetResumeTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetResumeTemplateResponse> {
            return localVarFp.resumeApiGetResumeTemplateById(requestParameters.resumeTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResumeApiApiResumeApiGetResumeTemplateListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiGetResumeTemplateList(requestParameters: ResumeApiApiResumeApiGetResumeTemplateListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllResumeTemplatesResponse> {
            return localVarFp.resumeApiGetResumeTemplateList(requestParameters.category, requestParameters.isActive, requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResumeApiApiResumeApiRegenerateResumeTemplateImagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiRegenerateResumeTemplateImages(requestParameters: ResumeApiApiResumeApiRegenerateResumeTemplateImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegenerateResumeTemplateImagesResponse> {
            return localVarFp.resumeApiRegenerateResumeTemplateImages(requestParameters.regenerateResumeTemplateImagesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResumeApiApiResumeApiUpdateResumeTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiUpdateResumeTemplateById(requestParameters: ResumeApiApiResumeApiUpdateResumeTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetResumeTemplateResponse> {
            return localVarFp.resumeApiUpdateResumeTemplateById(requestParameters.resumeTemplateId, requestParameters.updateResumeTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResumeApiApiResumeApiUploadResumeTemplateImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeApiUploadResumeTemplateImage(requestParameters: ResumeApiApiResumeApiUploadResumeTemplateImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadResumeTemplateResponse> {
            return localVarFp.resumeApiUploadResumeTemplateImage(requestParameters.imageFile, requestParameters.resumeTemplateId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for resumeApiCreateResumeTemplate operation in ResumeApiApi.
 */
export interface ResumeApiApiResumeApiCreateResumeTemplateRequest {
    readonly createResumeTemplateBody: CreateResumeTemplateBody
}

/**
 * Request parameters for resumeApiDeleteResumeTemplateById operation in ResumeApiApi.
 */
export interface ResumeApiApiResumeApiDeleteResumeTemplateByIdRequest {
    readonly resumeTemplateId: string
}

/**
 * Request parameters for resumeApiGetResumeTemplateById operation in ResumeApiApi.
 */
export interface ResumeApiApiResumeApiGetResumeTemplateByIdRequest {
    readonly resumeTemplateId: string
}

/**
 * Request parameters for resumeApiGetResumeTemplateList operation in ResumeApiApi.
 */
export interface ResumeApiApiResumeApiGetResumeTemplateListRequest {
    readonly category?: string

    readonly isActive?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for resumeApiRegenerateResumeTemplateImages operation in ResumeApiApi.
 */
export interface ResumeApiApiResumeApiRegenerateResumeTemplateImagesRequest {
    readonly regenerateResumeTemplateImagesBody: RegenerateResumeTemplateImagesBody
}

/**
 * Request parameters for resumeApiUpdateResumeTemplateById operation in ResumeApiApi.
 */
export interface ResumeApiApiResumeApiUpdateResumeTemplateByIdRequest {
    readonly resumeTemplateId: string

    readonly updateResumeTemplateBody: UpdateResumeTemplateBody
}

/**
 * Request parameters for resumeApiUploadResumeTemplateImage operation in ResumeApiApi.
 */
export interface ResumeApiApiResumeApiUploadResumeTemplateImageRequest {
    readonly imageFile: File

    readonly resumeTemplateId?: string
}

/**
 * ResumeApiApi - object-oriented interface
 */
export class ResumeApiApi extends BaseAPI {
    /**
     * 
     * @param {ResumeApiApiResumeApiCreateResumeTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resumeApiCreateResumeTemplate(requestParameters: ResumeApiApiResumeApiCreateResumeTemplateRequest, options?: RawAxiosRequestConfig) {
        return ResumeApiApiFp(this.configuration).resumeApiCreateResumeTemplate(requestParameters.createResumeTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResumeApiApiResumeApiDeleteResumeTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resumeApiDeleteResumeTemplateById(requestParameters: ResumeApiApiResumeApiDeleteResumeTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return ResumeApiApiFp(this.configuration).resumeApiDeleteResumeTemplateById(requestParameters.resumeTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResumeApiApiResumeApiGetResumeTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resumeApiGetResumeTemplateById(requestParameters: ResumeApiApiResumeApiGetResumeTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return ResumeApiApiFp(this.configuration).resumeApiGetResumeTemplateById(requestParameters.resumeTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResumeApiApiResumeApiGetResumeTemplateListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resumeApiGetResumeTemplateList(requestParameters: ResumeApiApiResumeApiGetResumeTemplateListRequest = {}, options?: RawAxiosRequestConfig) {
        return ResumeApiApiFp(this.configuration).resumeApiGetResumeTemplateList(requestParameters.category, requestParameters.isActive, requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResumeApiApiResumeApiRegenerateResumeTemplateImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resumeApiRegenerateResumeTemplateImages(requestParameters: ResumeApiApiResumeApiRegenerateResumeTemplateImagesRequest, options?: RawAxiosRequestConfig) {
        return ResumeApiApiFp(this.configuration).resumeApiRegenerateResumeTemplateImages(requestParameters.regenerateResumeTemplateImagesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResumeApiApiResumeApiUpdateResumeTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resumeApiUpdateResumeTemplateById(requestParameters: ResumeApiApiResumeApiUpdateResumeTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return ResumeApiApiFp(this.configuration).resumeApiUpdateResumeTemplateById(requestParameters.resumeTemplateId, requestParameters.updateResumeTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResumeApiApiResumeApiUploadResumeTemplateImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resumeApiUploadResumeTemplateImage(requestParameters: ResumeApiApiResumeApiUploadResumeTemplateImageRequest, options?: RawAxiosRequestConfig) {
        return ResumeApiApiFp(this.configuration).resumeApiUploadResumeTemplateImage(requestParameters.imageFile, requestParameters.resumeTemplateId, options).then((request) => request(this.axios, this.basePath));
    }
}

